var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_576_20216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 1.3335C9.66622 3.15906 10.6139 5.52819 10.6654 8.00016C10.6139 10.4721 9.66622 12.8413 7.9987 14.6668M7.9987 1.3335C6.33118 3.15906 5.38353 5.52819 5.33203 8.00016C5.38353 10.4721 6.33118 12.8413 7.9987 14.6668M7.9987 1.3335C4.3168 1.3335 1.33203 4.31826 1.33203 8.00016C1.33203 11.6821 4.3168 14.6668 7.9987 14.6668M7.9987 1.3335C11.6806 1.3335 14.6654 4.31826 14.6654 8.00016C14.6654 11.6821 11.6806 14.6668 7.9987 14.6668M1.66538 6.00016H14.332M1.66536 10.0002H14.332",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_576_20216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorld);
export default __webpack_public_path__ + "static/media/IconWorld.5a5dfcf0f2753bbd2dd84550aec74eb4.svg";
export { ForwardRef as ReactComponent };